module.exports = __webpack_public_path__ + "img/assorted-pharmaceutical-medicine-pills-tablets-and-3AKH6PB.3af4e529.jpg";